module.exports = __webpack_public_path__ + "img/chas.70209f68.png";